import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=1b6dd88e&scoped=true"
import script from "./VFooter.vue?vue&type=script&lang=ts"
export * from "./VFooter.vue?vue&type=script&lang=ts"
import style0 from "./VFooter.vue?vue&type=style&index=0&id=1b6dd88e&prod&lang=scss&scoped=true"
import style1 from "./VFooter.vue?vue&type=style&index=1&id=1b6dd88e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6dd88e",
  null
  
)

export default component.exports